import { all } from "redux-saga/effects";
import { dongBoHocPhiSaga } from "./dongBoHocPhiSaga";
import { dongBoPhiKyTucXaSaga } from "./dongBoPhiKyTucXaSaga";
import { dongBoCongNoSaga } from "./dongBoCongNoSaga";

export default function* dongBoSagaWrapper() {
  yield all([dongBoHocPhiSaga(), dongBoPhiKyTucXaSaga(), dongBoCongNoSaga()]);
}
